import { render, staticRenderFns } from "./Conference.vue?vue&type=template&id=2dcd41fb&scoped=true&"
import script from "./Conference.vue?vue&type=script&lang=ts&"
export * from "./Conference.vue?vue&type=script&lang=ts&"
import style0 from "./Conference.vue?vue&type=style&index=0&id=2dcd41fb&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dcd41fb",
  null
  
)

export default component.exports